var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { staticClass: "registry-workspace", attrs: { fluid: "" } },
    [
      _c("AdminBreadcrumb", {
        attrs: { name: "License Registry", items: [], "no-title": "" },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-between align-items-start mb-3",
        },
        [
          _c("h1", { staticClass: "h3 mb-0" }, [_vm._v("License Registry")]),
          _vm.canUpdate
            ? _c(
                "button",
                {
                  staticClass: "btn btn-success",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.openAction({ kind: "create-license" })
                    },
                  },
                },
                [_vm._v("+ Add license")]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "nav",
        {
          staticClass: "nav nav-tabs mb-3",
          attrs: { "aria-label": "Registry sections" },
        },
        _vm._l(_vm.sections, function (item) {
          return _c(
            "button",
            {
              key: item.key,
              staticClass: "nav-link",
              class: { active: _vm.state.section === item.key },
              attrs: {
                type: "button",
                "aria-current": _vm.state.section === item.key ? "page" : null,
              },
              on: {
                click: function ($event) {
                  return _vm.navigate({ section: item.key })
                },
              },
            },
            [_vm._v(_vm._s(item.label))]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.notice
        ? _c(
            "div",
            {
              staticClass: "alert alert-info small",
              attrs: { role: "status" },
            },
            [
              _vm._v(_vm._s(_vm.notice)),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button", "aria-label": "Dismiss notice" },
                  on: {
                    click: function ($event) {
                      _vm.notice = ""
                    },
                  },
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("×"),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.metadataError
        ? _c(
            "div",
            {
              staticClass: "alert alert-warning small",
              attrs: { role: "alert" },
            },
            [
              _vm._v(_vm._s(_vm.metadataError) + " "),
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-link",
                  attrs: { type: "button" },
                  on: { click: _vm.loadMetadata },
                },
                [_vm._v("Retry settings")]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.state.section === "licenses"
        ? [
            _c("div", { staticClass: "registry-paper p-3 mb-3" }, [
              _c(
                "form",
                {
                  staticClass: "registry-search",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.search.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("div", [
                    _c("label", { attrs: { for: "registry-search" } }, [
                      _vm._v("Business name or license number"),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.draftQuery,
                          expression: "draftQuery",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        id: "registry-search",
                        placeholder: "Search names or license numbers",
                      },
                      domProps: { value: _vm.draftQuery },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.draftQuery = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("label", { attrs: { for: "registry-state" } }, [
                      _vm._v("Issuing state"),
                    ]),
                    _c(
                      "select",
                      {
                        key: `state:${_vm.controlRevision}`,
                        staticClass: "custom-select",
                        attrs: { id: "registry-state" },
                        domProps: { value: _vm.state.filters.state },
                        on: {
                          change: function ($event) {
                            return _vm.filterChange("state", $event)
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v("All states"),
                        ]),
                        _vm._l(_vm.issuingStates, function (code) {
                          return _c(
                            "option",
                            { key: code, domProps: { value: code } },
                            [_vm._v(_vm._s(code))]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("label", { attrs: { for: "registry-standing" } }, [
                      _vm._v("Standing"),
                    ]),
                    _c(
                      "select",
                      {
                        key: `standing:${_vm.controlRevision}`,
                        staticClass: "custom-select",
                        attrs: { id: "registry-standing" },
                        domProps: { value: _vm.state.filters.standing },
                        on: {
                          change: function ($event) {
                            return _vm.filterChange("standing", $event)
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v("All standings"),
                        ]),
                        _c("option", { attrs: { value: "active" } }, [
                          _vm._v("Active"),
                        ]),
                        _c("option", { attrs: { value: "non_active" } }, [
                          _vm._v("Non-active"),
                        ]),
                        _c("option", { attrs: { value: "uncertain" } }, [
                          _vm._v("Uncertain"),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "submit" },
                    },
                    [_vm._v("Search")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "registry-more" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary",
                        attrs: {
                          type: "button",
                          "aria-expanded": _vm.moreFilters,
                          "aria-controls": "registry-more-filters",
                        },
                        on: {
                          click: function ($event) {
                            _vm.moreFilters = !_vm.moreFilters
                          },
                        },
                      },
                      [
                        _vm._v("More filters"),
                        _vm.filterCount
                          ? _c("span", [
                              _vm._v(" (" + _vm._s(_vm.filterCount) + ")"),
                            ])
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.moreFilters
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "registry-more-panel registry-paper p-3",
                            attrs: { id: "registry-more-filters" },
                          },
                          [
                            _vm._l(_vm.optionalFilters, function (filter) {
                              return _c(
                                "div",
                                { key: filter.key, staticClass: "mb-2" },
                                [
                                  _c(
                                    "label",
                                    {
                                      attrs: {
                                        for: `registry-filter-${filter.key}`,
                                      },
                                    },
                                    [_vm._v(_vm._s(filter.label))]
                                  ),
                                  _c(
                                    "select",
                                    {
                                      key: `${filter.key}:${_vm.controlRevision}`,
                                      staticClass:
                                        "custom-select custom-select-sm",
                                      attrs: {
                                        id: `registry-filter-${filter.key}`,
                                      },
                                      domProps: {
                                        value: _vm.state.filters[filter.key],
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.filterChange(
                                            filter.key,
                                            $event
                                          )
                                        },
                                      },
                                    },
                                    _vm._l(filter.options, function (option) {
                                      return _c(
                                        "option",
                                        {
                                          key: option.value,
                                          domProps: { value: option.value },
                                        },
                                        [_vm._v(_vm._s(option.text))]
                                      )
                                    }),
                                    0
                                  ),
                                ]
                              )
                            }),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-sm btn-link p-0",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    _vm.moreFilters = false
                                  },
                                },
                              },
                              [_vm._v("Close filters")]
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "small mt-2 text-right" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-link p-0",
                    attrs: { type: "button" },
                    on: { click: _vm.reset },
                  },
                  [_vm._v("Reset search")]
                ),
              ]),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class:
            _vm.state.section === "licenses"
              ? "registry-split"
              : ["registry-operations-layout", { "has-pane": _vm.showPane }],
        },
        [
          _vm.state.section === "licenses"
            ? _c(
                "aside",
                {
                  ref: "list",
                  staticClass: "registry-paper registry-result-rail",
                  attrs: { tabindex: "-1", "aria-label": "License results" },
                },
                [
                  _vm.listLoading
                    ? _c(
                        "div",
                        { staticClass: "p-4 small", attrs: { role: "status" } },
                        [_vm._v("Loading licenses…")]
                      )
                    : _vm.listError
                    ? _c(
                        "div",
                        {
                          staticClass: "p-3 text-danger small",
                          attrs: { role: "alert" },
                        },
                        [
                          _vm._v(_vm._s(_vm.listError) + " "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-outline-danger",
                              attrs: { type: "button" },
                              on: { click: _vm.loadList },
                            },
                            [_vm._v("Retry")]
                          ),
                        ]
                      )
                    : [
                        !_vm.rows.length
                          ? _c("div", { staticClass: "p-4" }, [
                              _c("h2", { staticClass: "h6" }, [
                                _vm._v("No matching licenses"),
                              ]),
                              _c("p", { staticClass: "small mb-0" }, [
                                _vm._v(
                                  "Try another name or number, or clear filters."
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "registry-rail-list" },
                          _vm._l(_vm.rows, function (row) {
                            return _c(
                              "button",
                              {
                                key: row.id,
                                staticClass: "registry-rail-item",
                                class: {
                                  "is-selected":
                                    _vm.state.selected === String(row.id),
                                },
                                attrs: {
                                  type: "button",
                                  "aria-pressed":
                                    _vm.state.selected === String(row.id),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectLicense(row.id)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "d-flex justify-content-between mb-1",
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(row.identity.issuing_state) +
                                          " " +
                                          _vm._s(
                                            _vm.text(
                                              row.identity.display_number
                                            )
                                          )
                                      ),
                                    ]),
                                    _c(
                                      "b-badge",
                                      {
                                        attrs: {
                                          variant: _vm.standingColor(
                                            row.standing.value
                                          ),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.standingLabel(
                                              row.standing.value
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c("strong", { staticClass: "d-block" }, [
                                  _vm._v(_vm._s(_vm.recordName(row))),
                                ]),
                                _vm.value(row, "legal_name") &&
                                _vm.value(row, "legal_name") !==
                                  _vm.recordName(row)
                                  ? _c(
                                      "small",
                                      { staticClass: "d-block text-muted" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.text(
                                              _vm.value(row, "legal_name")
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "small",
                                  { staticClass: "d-block text-muted mt-1" },
                                  [_vm._v(_vm._s(_vm.rowLocation(row)))]
                                ),
                                ((row.identity_conflict || {}).open || [])
                                  .length
                                  ? _c(
                                      "small",
                                      { staticClass: "d-block text-danger" },
                                      [_vm._v("Identity dispute")]
                                    )
                                  : _vm._e(),
                                row.local_inactivation
                                  ? _c(
                                      "small",
                                      { staticClass: "d-block text-muted" },
                                      [_vm._v("Inactivated by admin")]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "p-3 border-top registry-pager" },
                          [
                            _c(
                              "strong",
                              {
                                staticClass: "small",
                                attrs: { "aria-live": "polite" },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.total) +
                                    " " +
                                    _vm._s(
                                      _vm.total === 1 ? "result" : "results"
                                    )
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center justify-content-between mt-2",
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-sm btn-outline-secondary",
                                    attrs: {
                                      type: "button",
                                      disabled: _vm.state.page <= 1,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.navigate({
                                          page: _vm.state.page - 1,
                                        })
                                      },
                                    },
                                  },
                                  [_vm._v("Previous")]
                                ),
                                _c("span", { staticClass: "small" }, [
                                  _vm._v(
                                    "Page " +
                                      _vm._s(_vm.state.page) +
                                      " of " +
                                      _vm._s(_vm.lastPage)
                                  ),
                                ]),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-sm btn-outline-secondary",
                                    attrs: {
                                      type: "button",
                                      disabled: _vm.state.page >= _vm.lastPage,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.navigate({
                                          page: _vm.state.page + 1,
                                        })
                                      },
                                    },
                                  },
                                  [_vm._v("Next")]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ],
                ],
                2
              )
            : _c("div", { staticClass: "registry-paper" }, [
                _c(
                  "fieldset",
                  {
                    staticClass: "border-0 p-0 m-0",
                    attrs: {
                      disabled: !!_vm.action && _vm.state.section === "imports",
                      "aria-label": "Registry section",
                    },
                  },
                  [
                    _c("RegistryOperations", {
                      key: `${_vm.state.section}:${_vm.operationsRevision}`,
                      ref: "operations",
                      attrs: {
                        section: _vm.state.section,
                        "can-update": _vm.canUpdate,
                        metadata: _vm.metadata,
                        "before-navigate": _vm.beforeOperationsNavigate,
                        "sync-route": _vm.syncOperationsRoute,
                      },
                      on: {
                        "open-license": function ($event) {
                          return _vm.openLicense($event, true)
                        },
                        "open-entity": function ($event) {
                          return _vm.openEntity($event, true)
                        },
                        action: _vm.openAction,
                        changed: _vm.operationsChanged,
                      },
                    }),
                  ],
                  1
                ),
              ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showPane,
                  expression: "showPane",
                },
              ],
              staticClass: "registry-right-pane",
            },
            [
              _vm.state.section === "licenses" &&
              (_vm.state.selected || _vm.state.entity || _vm.action)
                ? _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-sm btn-link registry-back-list mb-2",
                      attrs: { type: "button" },
                      on: { click: _vm.backToList },
                    },
                    [_vm._v("Back to results")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.action
                ? _c("RegistryActionPanel", {
                    key: _vm.actionKey,
                    ref: "action",
                    staticClass: "registry-paper",
                    attrs: {
                      action: _vm.action,
                      "can-update": _vm.canUpdate,
                      metadata: _vm.metadata,
                      "before-navigate": _vm.beforeNavigate,
                    },
                    on: {
                      cancel: function ($event) {
                        _vm.action = null
                      },
                      saved: _vm.saved,
                      "open-license": function ($event) {
                        return _vm.openLicense($event, true)
                      },
                      "open-entity": function ($event) {
                        return _vm.openEntity($event, true)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.action,
                      expression: "!action",
                    },
                  ],
                },
                [
                  _vm.state.entity
                    ? _c("div", { staticClass: "mb-3" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-link p-0",
                            attrs: { type: "button" },
                            on: { click: _vm.backFromEntity },
                          },
                          [
                            _vm._v(
                              "← " +
                                _vm._s(
                                  _vm.state.selected
                                    ? "Back to license"
                                    : "Back to entities"
                                )
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.state.entity
                    ? _c(
                        "div",
                        { staticClass: "registry-entity-pane" },
                        [
                          _vm.entityLoading
                            ? _c(
                                "div",
                                {
                                  staticClass: "registry-paper p-4",
                                  attrs: { role: "status" },
                                },
                                [_vm._v("Loading entity…")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.entityError
                            ? _c(
                                "div",
                                {
                                  staticClass: "registry-paper p-4 text-danger",
                                  attrs: { role: "alert" },
                                },
                                [
                                  _vm._v(_vm._s(_vm.entityError) + " "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-sm btn-outline-danger",
                                      attrs: { type: "button" },
                                      on: { click: _vm.loadEntity },
                                    },
                                    [_vm._v("Retry")]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.entity
                            ? _c("RegistryEntityProfile", {
                                key: `${_vm.entity.type}:${_vm.entity.id}`,
                                ref: "entityProfile",
                                attrs: {
                                  entity: _vm.entity,
                                  possible: _vm.state.possible,
                                  "can-update": _vm.canUpdate,
                                  metadata: _vm.metadata,
                                  "detail-tab": _vm.state.entityTab,
                                  "before-navigate": _vm.beforeNavigate,
                                },
                                on: {
                                  tab: function ($event) {
                                    return _vm.navigate({ entityTab: $event })
                                  },
                                  "open-entity": _vm.openEntity,
                                  "open-license": _vm.openLicense,
                                  action: _vm.openAction,
                                  saved: _vm.saved,
                                  reload: _vm.reloadEntity,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.state.entity,
                          expression: "!state.entity",
                        },
                      ],
                    },
                    [
                      _vm.detailLoading
                        ? _c(
                            "div",
                            {
                              staticClass: "registry-paper p-4",
                              attrs: { role: "status" },
                            },
                            [_vm._v("Loading license…")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.detailError
                        ? _c(
                            "div",
                            {
                              staticClass: "registry-paper p-4 text-danger",
                              attrs: { role: "alert" },
                            },
                            [
                              _vm._v(_vm._s(_vm.detailError) + " "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-sm btn-outline-danger",
                                  attrs: { type: "button" },
                                  on: { click: _vm.loadDetail },
                                },
                                [_vm._v("Retry")]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.detail
                        ? _c("RegistryLicenseProfile", {
                            key: _vm.detail.id,
                            ref: "licenseProfile",
                            attrs: {
                              license: _vm.detail,
                              "can-update": _vm.canUpdate,
                              metadata: _vm.metadata,
                              "detail-tab": _vm.state.licenseTab,
                              "refresh-key": _vm.refreshKey,
                              "before-navigate": _vm.beforeNavigate,
                            },
                            on: {
                              tab: function ($event) {
                                return _vm.navigate({ licenseTab: $event })
                              },
                              "open-entity": _vm.openEntity,
                              "open-license": _vm.openLicense,
                              action: _vm.openAction,
                              saved: _vm.saved,
                              reload: _vm.reloadLicense,
                            },
                          })
                        : !_vm.state.selected
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "registry-paper p-5 text-center text-muted",
                            },
                            [
                              _c("h2", { staticClass: "h5" }, [
                                _vm._v("Choose a license"),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }